import React from "react";
import PropTypes from 'prop-types'
import Button from "@material-ui/core/Button";
import makeStyles from "@material-ui/core/styles/makeStyles";
import JsonScreenHoc from "../../../../../../HocHelpers/JsonScreenHoc";
import {getParamsFromString} from "../../../../Utils";
import {useSelector} from "react-redux";

const useStyles = makeStyles(() => ({
    container: {
        height: 40,
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        alignItems: 'center'
    }
}));
const ActionsBar = (props) => {
    const {
        component: {properties}, doActions, screenName, loadingData
    } = props;
    const {globalValues} = useSelector(state => state.jsonScreen);
    const classes = useStyles();
    const recordID = getParamsFromString('{inParam.id}', globalValues, screenName);
    const actions = {
        create: () => {
            props.submitFnRef.current = async () => {
                doActions([{
                    type: "createEntity",
                    destination: properties.entity,
                    param: [{}]
                }])
            }
        },
        update: () => {
            props.submitFnRef.current = async () => {
                doActions([{
                    type: "updateEntity",
                    destination: properties.entity,
                    param: [{}]
                }])
            }
        },
        delete: () => {
            doActions([{
                type: "deleteEntity",
                destination: properties.entity,
                recordId: recordID,
                param: [{}]
            }])
        },
        cancel: () => {
            doActions([{
                type: "cancel",
                param: [{}],
            }])
        }
    };

    return (
        <div className={classes.container}>
            <Button
                size={"small"} variant={"contained"}
                type={'submit'}
                color={"primary"}
                disabled={loadingData}
                form={screenName + '_screenForm'}
                onClick={recordID ? actions.update : actions.create}
            >
                {recordID ? 'Update' : 'Create'}
            </Button>
            {recordID && (
                <Button
                    size={"small"} variant={"outlined"}
                    color={"secondary"} style={{marginLeft: 5}}
                    onClick={actions.delete}
                    disabled={loadingData}
                >
                    Delete
                </Button>
            )}
            <Button
                size={"small"} variant={"contained"}
                color={"default"} style={{marginLeft: 5}}
                onClick={actions.cancel}
                disabled={loadingData}
            >
                Cancel
            </Button>
        </div>
    )
};
ActionsBar.propTypes = {
    component: PropTypes.object,
    doActions: PropTypes.func
};

export default JsonScreenHoc(ActionsBar)